module.exports = __webpack_public_path__ + "static/costs-1dc666a970433c34849252f051a46c1a.svg";